/** @format */

'use strict';

//The factory to crud the main object
angular.module('emsApp').factory('CarFactory', function($resource) {
	return $resource(
		'api/cars/:id',
		{},
		{
			query: { method: 'GET', isArray: false },
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
			update: { method: 'PUT' },
		}
	);
});

//The factory to fetch a new object with defaults from server
angular.module('emsApp').factory('NewCarFactory', function($resource) {
	return $resource(
		'api/cars/new',
		{},
		{
			get: {
				method: 'GET',
				transformResponse: function(data) {
					data = angular.fromJson(data);
					return data;
				},
			},
		}
	);
});

//Get all Cars without the use of paging
angular.module('emsApp').factory('NoPagingCarFactory', function($resource) {
	return $resource(
		'api/cars/nopaging',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

// find all articles filtered by articleforrental
angular.module('emsApp').factory('CarFindArticleFilteredByArticleForRentalFactory', function($resource) {
	return $resource(
		'api/cars/article/filteredby/articleforrental',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('SubscriptionsByCarFactory', function($resource) {
	return $resource(
		'api/subscriptions/car/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

//For the tab-window of n-relations in the detail view.
angular.module('emsApp').factory('DocumentsByCarFactory', function($resource) {
	return $resource(
		'api/documents/car/:id',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('FindAllCarsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/query/cars/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('AutocompleteCarsByQueryParamsFactory', function($resource) {
	return $resource(
		'api/autocomplete/cars/',
		{},
		{
			query: { method: 'GET', isArray: true },
		}
	);
});

angular.module('emsApp').factory('CarSaveAndCreateFactory', function($resource) {
	return $resource(
		'api/cars/createandnew/:id',
		{},
		{
			saveAndCreate: { method: 'POST' },
			updateAndCreate: { method: 'PUT' },
		}
	);
});
